export default __webpack_public_path__ + "static/media/bi_stars.d30a8833.svg";